<template>
<div class="chapter">
<div class="inner_page">
<p class="sert">“Fear not, I am the first and the last, and the living one…</p>
<p class="ser">and I have the keys to Death and Hades. Now write what you see,</p>
<p class="ser">what is and what is to take place hereafter….</p>
<p class="ser2">“To him who conquers I will give some of the hidden manna,</p>
<p class="ser">and I will give him a white stone, with a new name written on the stone</p>
<p class="ser">which no one knows except him who receives it.</p>
<p class="ser2">“Therefore I counsel you to buy from me gold refined by fire,</p>
<p class="ser">that you may be rich, and white garments to clothe you….”</p>
<p class="ser2">Revelation 1:17-19; 2:17; 3:18, RSV</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hell_and_Beyond_Split5.vue?1bd9e5bc